import { useMutation, useQueryClient } from "@tanstack/react-query";

import { addOrUpdateProgramParticipation, deleteProgramParticipation } from "services";

import { ADD_FARM_TO_CARBON_PROGRAM, GET_FARMS_BY_CARBON_PROGRAM } from "consts";

export const useAddOrUpdateProgramParticipation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: [ADD_FARM_TO_CARBON_PROGRAM],
    mutationFn: addOrUpdateProgramParticipation,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [GET_FARMS_BY_CARBON_PROGRAM] });
    },
  });
};

export const useDeleteProgramParticipation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: deleteProgramParticipation,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [GET_FARMS_BY_CARBON_PROGRAM] });
    },
  });
};
